import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetChargePointsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/inputs/get-charge-points-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchChargePointListContext } from '../../charge-point.context';
import { ChargePointListFilterSearchFormStep1Controller } from '../charge-point-list-filter-search-form-step-1/charge-point-list-filter-search-form-step-1.controller';

export interface ChargePointListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetChargePointsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetChargePointsPaginatedModel>;
  onCancel: () => void;
}

export const ChargePointListFilterSearchFormController = (
  props: ChargePointListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchChargePointListContext();

  return (
    <HeadlessFormProvider<GetChargePointsPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <ChargePointListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
